var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("field-" + (_vm.field.size))},[_c(_vm.getComponent(_vm.field.type),{tag:"component",attrs:{"field":_vm.field,"full-key":_vm.fullKey,"form":_vm.form}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }